import styled from 'styled-components';

export const Container = styled.div`
background: #000;
display: flex;
justify-content: center;
align-items: center;
padding: 0 30px;
height: 1450px;
position: relative;
z-index: 1;

@media screen and (max-width: 720px) {
  height: 1900px;
}

@media screen and (max-width: 480px) {
  height: 2300px;
}

:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #eae9e9
    z-index: 2;
}
`;


export const Card = styled.div`
background: #f2f2f2;
display: flex;
flex-direction: column;
justify-content: space-evenly;
align-items: center;
border-radius: 10px;
max-height: 1400px;
padding: 30px;
position: center;
left: 30px;
  right: 30px;
  top: 0px;
  bottom: 0px;
  width: 1200px;
box-shadow: 0 1px 3px rgba(0,0,0,0.2);

@media screen and (max-width: 720px) {
  max-height: 6000px;
}

@media screen and (max-width: 480px) {
  max-height: 8000px;
} 
`;

export const P = styled.p`
font-size: 15px;
text-align: left;
padding: 10px;
padding-left: 65px;
padding-right: 65px;

@media screen and (max-width: 480px) {
  padding-left: 5px;
  padding-right: 5px;
  font-size: 13px;
}
`;

export const H1 = styled.h1`
font-size: 2.5rem;
color: #000;
margin-bottom: 30px;

@media screen and (max-width: 480px) {
    font-size: 1.6rem;
}
`;

export const H2 = styled.h2`
font-size: 1rem;
margin-bottom: 15px;

@media screen and (max-width: 480px) {
  padding-left: 5px;
  font-size: 15px;
}
`;